"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("../../themes/main/colors");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var open = _a.open;
            return ({
                display: !open ? "none" : "flex",
                position: "absolute",
                zIndex: theme.zIndex.modal + 1,
                top: 0,
                left: 0,
                right: 0,
                width: "100vw",
                minHeight: "100vh",
                alignItems: "stretch",
            });
        },
        pagingButton: {
            display: "flex",
            flexGrow: 0,
            alignItems: "center",
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
        },
        button: {
            backgroundColor: "#fff",
            paddingTop: "34px",
            paddingBottom: "34px",
            paddingLeft: "4px",
            paddingRight: "4px",
            minWidth: "32px",
            "&:hover": {
                backgroundColor: "#fff",
            },
        },
        contentWindow: {
            justifyContent: "space-between",
            height: "90vh",
            minWidth: "400px",
            alignSelf: "center",
            alignItems: "stretch",
            flexGrow: 1,
            paddingRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
        },
        closeButton: {
            marginLeft: "-12px",
        },
        content: {
            padding: theme.spacing(2),
            flexGrow: 1,
        },
        drawer: function (_a) {
            var drawerWidth = _a.drawerWidth;
            return ({
                backgroundColor: "#fff",
                paddingRight: theme.spacing(2),
                paddingLeft: theme.spacing(2),
                alignSelf: "stretch",
                width: drawerWidth,
                order: 1,
            });
        },
        drawerActions: {
            display: "flex",
            justifyContent: "space-between",
            paddingTop: theme.spacing(2),
            alignItems: "center",
        },
        drawerTitle: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            "& div:first-child": {
                marginBottom: theme.spacing(1),
            },
        },
        drawerSubtitle: {
            fontSize: "12px",
            fontWeight: "bold",
            color: colors_1.materialColors.grey[400],
        },
        actionButtons: {
            flexGrow: 1,
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "flex-end",
            // TODO: this should become a new "size" variant for button
            "& > .MuiButton-root": {
                fontSize: "11px",
                padding: "8px 12px",
                minWidth: "60px",
            },
        },
    });
});
